import type { WhatsNewBody } from '../types';

export default {
  title: 'Read the finalized Weekly Report in the Project Tracker',
  summary:
    'Once a week’s report is uploaded, the Weekly Report tab shows it whole, so nobody has to open the Word file in SharePoint to read it. A toggle switches between the Project Tracker’s draft (Before upload) and the report as filed (After upload), and everything typed in last week’s report now starts the next one.',
  details: [
    'A week with an uploaded report opens on After upload.',
    'Only the daily logs’ site photos show, not images pasted into Word.',
    'After you edit the file in SharePoint, click Read the file again.',
  ],
  tryIt: { to: '/projects', label: 'Open Projects' },
  guide: { topic: 'mod-weekly-after' },
} satisfies WhatsNewBody;
